
export const FILTER_OUTLINE_ID = 'filter--outline';

export const FilterOutline = () => (
  <filter id={FILTER_OUTLINE_ID}>
    <feMorphology operator="dilate" in="SourceAlpha" radius="4" result="DILATED" />
    <feFlood floodColor="#FFD700" floodOpacity="1" result="COLOR" />
    <feComposite in="COLOR" in2="DILATED" operator="in" result="OUTLINE" />

    <feMerge>
      <feMergeNode in="OUTLINE" />
      <feMergeNode in="SourceGraphic" />
    </feMerge>
  </filter>
);
